import { render, staticRenderFns } from "./ExportShipment.vue?vue&type=template&id=0fc09aa8&"
import script from "./ExportShipment.vue?vue&type=script&lang=js&"
export * from "./ExportShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports